import { render, staticRenderFns } from "./modal-attach-proofs.vue?vue&type=template&id=2998d30a&scoped=true&"
import script from "./modal-attach-proofs.vue?vue&type=script&lang=js&"
export * from "./modal-attach-proofs.vue?vue&type=script&lang=js&"
import style0 from "./modal-attach-proofs.vue?vue&type=style&index=0&id=2998d30a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2998d30a",
  null
  
)

export default component.exports